import React, { FC } from 'react'
import { MapLocationListProps } from './MapLocationList-types'
import { styles } from './MapLocationList-styles'
import { CustomScroll } from 'atoms/CustomScroll'

export const MapLocationList: FC<MapLocationListProps> = ({ list, onSelect }) => {
    const renderList = () => {
        return list.map((item, index) => {
            const { id, name, description, lat, lng } = item
            const key = id != null ? `map-location-${id}` : `map-location-${index}_${lat ?? 'null'}_${lng ?? 'null'}`

            return (
                <div key={key} className={styles.mapLocationList__item} onClick={() => onSelect(item)}>
                    <strong>{name}</strong> {description}
                </div>
            )
        })
    }
    return (
        <div className={styles.mapLocationList}>
            <CustomScroll classNames={styles.mapLocationList__content}>{renderList()}</CustomScroll>
        </div>
    )
}
